function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useEffect } from 'react';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
var adBridgInit = function adBridgInit(_ref) {
  var config = _ref.config,
    data = _ref.data;
  var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.log;
  log('Initialising Adbridg');
  if (typeof window === 'undefined') {
    log('Not client side, doing nothing');
    return;
  }
  var defaultData = {
    adsite: 'ALLHOMES.COM.AU',
    e: window.location.href.includes('qa.allhomes') ? 'www.qa.allhomes.com.au' : 'www.allhomes.com.au'
  };
  window.AdBridg = window.AdBridg || {
    cmd: []
  };
  window.googletag = window.googletag || {
    cmd: []
  };
  var payload = {
    action: 'spa_pv_initialize',
    config,
    targeting: _objectSpread(_objectSpread({}, defaultData), data)
  };
  log('Pushing adbridg payload:', payload);
  window.AdBridg.cmd.push(payload);
};
var adBridgShutdown = log => {
  var _window$AdBridg;
  log('Shutting down adbridg');
  if (typeof window === 'undefined') {
    log('Not client side, doing nothing');
    return;
  }
  var payload = {
    action: 'spa_pv_shutdown'
  };
  log('Pushing adbridg payload:', payload);
  (_window$AdBridg = window.AdBridg) === null || _window$AdBridg === void 0 ? void 0 : _window$AdBridg.cmd.push(payload);
};
export var useAdbridg = _ref2 => {
  var _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    config = _ref2.config,
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? {} : _ref2$data;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var log = function log() {
    if (toggledFeatures.ANALYTICS_DEBUG) {
      console.log(...arguments);
    }
  };
  var configStr = JSON.stringify(config);
  var dataStr = JSON.stringify(data);
  useEffect(() => {
    log('In useAdbridg useEffect - either first time, or the targetting changed');
    if (disabled || !config) {
      log('Disabled, so exiting');
      return () => {};
    }
    log('Initialising AdBridg');
    adBridgInit({
      config,
      data
    }, log);
    return () => {
      adBridgShutdown(log);
    };
  }, [configStr, dataStr, disabled]);
};